import { useQuery } from '@tanstack/react-query';
import { useAuthStatus } from 'features/auth';
import { fetchMyProfile } from './myProfileApi';
export function useMyProfile() {
    const status = useAuthStatus();
    const user = status.kind === 'authenticated' ? status.user : null;
    return useQuery({
        queryKey: ['myProfile', user?.email],
        queryFn: () => {
            if (!user)
                throw new Error('Not authenticated');
            return fetchMyProfile(user);
        },
        enabled: Boolean(user),
        retry: false,
        staleTime: 0,
    });
}
